<script setup>
import ProjectLayout from "@/layouts/ProjectLayout.vue";
import { ref } from "vue";

const { pending, data: projects } = await useFetch(
  "http://black.irumva.pro/api/project/command",
  {
    lazy: false,
  }
);

const selectedProject = ref(null);
const selectProject = (project) => {
  selectedProject.value = project;
};

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const invertTextColor = () => {
  return "#fff";
};
</script>

<template>
  <ProjectLayout>
    <div v-if="pending">
      <p>Loading...</p>
    </div>

    <div v-else class="flex ml-[-1.5em] top-0 h-[29rem]">
      <div
        class="grid grid-cols-1 gap-2 py-4 ml-6 w-8/10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 overflow-y-auto"
      >
        <div
          v-for="project in projects"
          :key="project.id"
          class="flex border border-[#575041] rounded mr-5"
          @click="selectProject(project)"
        >
          <div class="w-full h-50">
            <NuxtLink :to="preview">
              <div class="flex justify-center">
                <NuxtImg
                  :src="project.image"
                  class="w-full h-auto justify-center filter grayscale sepia hue-rotate-180 brightness-75 duration-30 hover:filter-none"
                  :placeholder="[60, 60]"
                />
              </div>
              <div class="bg-[#776849] py-2 mb-0 bottom-0">
                <p class="font-mono text-sm text-[#0e0d0d] text-center py-2">
                  {{ project.name }}
                </p>
              </div>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </ProjectLayout>
</template>

<style scoped>
.font-mono {
  font-family: "Courier New", Courier, monospace;
}
@media (min-width: 640px) {
  .mt-10 {
    margin-top: 10em;
  }
}
</style>
